import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/grid.module.css';

import type { TAs, TGridProps } from './types';

const Grid = <T extends TAs>({
  children,
  className,
  as,
  innerRef,
  /* These two props are not used in the grid component, but are used in the styled components
    * they are used in the Hero grid that extends the grid component. They are not used in the
    * grid component itself, but will cause console errors if passed through to the <Component> tag
  */
  textAlignment,
  hasForm,
  ...rest
}: TGridProps<T>) => {
  const Component = as || 'div';

  return (
    <Component
      {...rest}
      className={generateClassName([styles.baseGrid, className])}
      ref={innerRef}
    >
      {children}
    </Component>
  );
};

export const ModulesGrid = ({
  children,
  className,
  innerRef,
  ...rest
}: TGridProps<'div'>) => (
  <div className={generateClassName([className, styles.grid])} ref={innerRef} {...rest}>{children}</div>
);

export default Grid;
